import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import SummaryHistoryPagesRepository from 'clients/db/SummaryHistoryPagesRepository'
import SummaryHistoryPage from 'model/SummaryHistoryPage'
import { AppThunk } from '../../store'

interface SummaryHistoryState {
  isLoading: boolean
  summaryHistoryPages: SummaryHistoryPage[]
}

const initialState: SummaryHistoryState = {
  isLoading: false,
  summaryHistoryPages: [],
}

function startLoading(state: SummaryHistoryState) {
  state.isLoading = true
}

const SummaryHistorySlice = createSlice({
  name: 'summaryHistory',
  initialState,
  reducers: {
    fetchSummaryHistoryStart: startLoading,
    fetchSummaryHistoryFirstPageSuccess: (
      state,
      { payload }: PayloadAction<SummaryHistoryPage>,
    ) => {
      state.isLoading = false
      state.summaryHistoryPages = [payload]
    },
    fetchSummaryHistoryPageSuccess: (state, { payload }: PayloadAction<SummaryHistoryPage>) => {
      state.isLoading = false
      state.summaryHistoryPages = [...state.summaryHistoryPages, payload]
    },
  },
})
export const {
  fetchSummaryHistoryStart,
  fetchSummaryHistoryFirstPageSuccess,
  fetchSummaryHistoryPageSuccess,
} = SummaryHistorySlice.actions

export const fetchSummaryHistoryPage = (selector: any, bookmark: string): AppThunk => async (
  dispatch,
) => {
  dispatch(fetchSummaryHistoryStart())

  let summaryHistoryPages
  summaryHistoryPages = await SummaryHistoryPagesRepository.searchSummaryHistoryPage(
    selector,
    bookmark,
  )

  if (bookmark === '') {
    dispatch(fetchSummaryHistoryFirstPageSuccess(summaryHistoryPages))
  } else {
    dispatch(fetchSummaryHistoryPageSuccess(summaryHistoryPages))
  }
}

export default SummaryHistorySlice.reducer
